import React, { Component } from 'react';
import { Row } from 'antd';
import i18n from 'react-intl-universal';
import styles from './NotFoundPage.scss';

import logo from '../../assets/images/error_page_logo.png';
import notFoundImg from '../../assets/images/img_404.png';

import Button from '../../components/Button/Button';

export default class NotFoundPage extends Component {
  toHome = () => {
    window.location.href = window.location.origin;
  };

  render() {
    return (
      <Row className={styles['wrapper']}>
        <header className={styles['header']}>
          <img onClick={this.toHome} className={styles['logo']} src={logo} alt=""/>
        </header>
        <div className={styles['content']}>
          <img className={styles['img-404']} src={notFoundImg} alt=""/>
          <h3 className={styles['title']}>
            {i18n.get('not-found.title')}
          </h3>
          <p className={styles['desc']}>
            {i18n.get('not-found.desc')} : <strong>{window.location.href}</strong>
          </p>
          <Button onClick={this.toHome} className={styles['btn']} type={'primary'} strong>
            {i18n.get('not-found.to-home')}
          </Button>
        </div>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/NotFoundPage/NotFoundPage.js